import throttle from "lodash/throttle";
import { useEffect, useRef, useState } from "react";

/** Detect whether a given element is on the screen. */
export const useOnScreen = <Element extends HTMLElement>(
  offset = 0,
  throttleMilliseconds = 100,
  initialValue = false,
): [boolean, any] => {
  const [isVisible, setIsVisible] = useState(initialValue);
  const currentElement = useRef<Element>(null);

  const onScroll = throttle(() => {
    if (!currentElement.current) {
      setIsVisible(false);
      return;
    }
    const top = currentElement.current.getBoundingClientRect().top;
    setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight);
  }, throttleMilliseconds);

  useEffect(() => {
    document.addEventListener("scroll", onScroll, true);
    return () => document.removeEventListener("scroll", onScroll, true);
  }, []);

  return [isVisible, currentElement];
};
